import { render, staticRenderFns } from "./PackagesIsps.vue?vue&type=template&id=1a45a00e&scoped=true&"
import script from "./PackagesIsps.vue?vue&type=script&lang=js&"
export * from "./PackagesIsps.vue?vue&type=script&lang=js&"
import style0 from "./PackagesIsps.vue?vue&type=style&index=0&id=1a45a00e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a45a00e",
  null
  
)

export default component.exports